import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const getNotifications = async () => {
  try {
    const params = new URLSearchParams({ limit: 10 });
    return await apiClient.get(`${apiEndpoint}${API.NOTIFICATION.GET}?${params}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getNotificationSettings = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.NOTIFICATION_SETTINGS.GET}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const addUserToReadList = async (notificationId) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.NOTIFICATION.UPDATE}${notificationId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const clearAllNotification = async () => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.NOTIFICATION.UPDATE_CLEAR}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateNotificationSetting = async (notificationSettings) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.NOTIFICATION_SETTINGS.UPDATE}`, notificationSettings);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveSettingService = async (notificationSettings) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.NOTIFICATION.USER_NOTIFICATION_UPDATE}`, notificationSettings);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getUserNotificationSetting = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.NOTIFICATION.USER_NOTIFICATION_GET}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchNotificationListService = async (data) => {
  try {
    const params = new URLSearchParams({ ...data });
    return await apiClient.get(`${apiEndpoint}${API.NOTIFICATION.USER_NOTIFICATION_LIST}?${params}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addUserNotificationToReadList = async (notificationId) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.NOTIFICATION.USER_NOTIFICATION_READ}${notificationId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const clearAllUserNotification = async () => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.NOTIFICATION.USER_NOTIFICATION_ALL_CLEAR}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
